import React from 'react';
import FormulationInput from 'screens/ProductList/components/FormulationInput';
import { Col, Row, Typography } from 'syngenta-digital-cropwise-react-ui-kit';

const FIELDS = {
  major: ['N', 'P', 'K'],
  minor: ['Ca', 'Mg', 'S'],
  micro: ['Fe', 'Cu', 'Mn', 'Zn', 'B', 'Mo', 'Cl']
};

const FormulationFields = () => {
  return (
    <div className="flex flex-col gap-7 mt-4">
      {(Object.keys(FIELDS) as Array<keyof typeof FIELDS>).map(sectionName => (
        <div key={sectionName} className="flex flex-col gap-5">
          <Typography.Title strong level={3} className="text-base">
            {sectionName.charAt(0).toUpperCase() + sectionName.slice(1)}
          </Typography.Title>
          <Row gutter={32}>
            {FIELDS[sectionName].map(field => (
              <Col span={6} key={field}>
                <FormulationInput fieldValue={field} />
              </Col>
            ))}
          </Row>
        </div>
      ))}
    </div>
  );
};

export default FormulationFields;
